import React from "react";

import UserListItem from "./UserListItem";
import NoResults from "../../../common/NoResults";
import { SonicUser } from "../../../common/classes/SonicUser";

import styles from "../../management/db-list/DBList.module.scss";

type ListProps = {
  users: SonicUser[];
};

const UserList: React.FC<ListProps> = ({ users }) => {
  if (users.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["member"]}`}
      >
        <div>会員名</div>
        <div>会員タイプ</div>
        <div>メールアドレス</div>
        <div>アクション</div>
        <div>認証</div>
      </div>
      {users?.map((user, i) => (
        <UserListItem
          key={i}
          id={user.id}
          name={user.meta.name || "-"}
          type={user.roles}
          email={user.meta.email || "-"}
          active={user.meta.active === 1}
        />
      ))}
    </div>
  );
};

export default UserList;
